import { Component, Input } from '@angular/core';
import { IUnifiedMotorVehicleReport } from '../../../../core/interfaces/unified-background-check.interface';
import { IRecordCard } from '../../driver-background-check.view-models';
import { classColor as resolveClassColor } from '../../driver-background-check.constants';
import { formatDate } from '../../../helpers';

@Component({
  selector: 'app-bgc-section-mvr',
  templateUrl: './bgc-section-mvr.component.html',
  styleUrls: ['./bgc-section-mvr.component.scss', '../../driver-background-check.component.scss']
})
export class BgcSectionMvrComponent {
  @Input() report: IUnifiedMotorVehicleReport;
  @Input() violationCards: IRecordCard[] = [];
  @Input() accidentCards: IRecordCard[] = [];

  public readonly formatDate = formatDate;

  classColor(value: string): string {
    return resolveClassColor(value);
  }

  trackByCard(index: number, card: IRecordCard): string {
    return card.id;
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/driver-background-check/components/bgc-section-mvr/bgc-section-mvr.component.ts